module.exports = __webpack_public_path__ + "static/media/react.3b46bb3c.svg";